module.exports = __webpack_public_path__ + "media/components/insights/asset-icons/product-adc34f6ec991b1bbcb9def926e2fba99.png";